import { makeStyles } from '@material-ui/core/styles';

export const NavBarStyle = makeStyles((theme) => ({

  appBar: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    height: '80px',
    minHeight: '80px',
    // padding: '0px 28px',
    [theme.breakpoints.down('xs')]: {

    },
  },
  toolbar: {
    // maxWidth: '1440px',
    width: '100% ',
    // padding: '0px !important',
    margin: 'auto',
    height: '48px',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position:'fixed',
    // left: '0',
    // right: '0',
    minHeight: '80px',

    '& a': {
      border: 'none',
      outline: 'none',
      height: '81px',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      fontFamily: ['"Brown"'].join(','),
      letterSpacing: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      textAlign: 'center',
      fontWeight: '300',
      lineHeight: '1.4',
      // color: '#ffffff',
      fontSize: '18px',
      margin: '0px',
      padding: '5px 8px',
      textDecoration: 'none',
    },

    '& a:hover': {
      color: 'rgba(128,128,128,0.7)',
    },

    [theme.breakpoints.down('sm')]: {

    },
    [theme.breakpoints.down('xs')]: {
      height: '74px',
      // position:'relative',
    },
  },

  toolbarDiv: {
    alignSelf: 'center', 
    // marginTop: '24px',
    width: '15%',
    paddingLeft: '24px',

    '& svg:hover':{
      opacity: '0.5',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '0px',
      width: '35%',
    },
  },

  toolbarContainerOption:{
    paddingRight: '24px'
  },

  menuOption: {
    fontSize: '18px !important',
    marginLeft: '16px !important',
    color: '#ffffff',

    '& a:hover': {
      color: 'rgba(128,128,128,0.7)',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px !important',
    },
  },

  menuOptionBlack: {
    fontSize: '18px !important',
    marginLeft: '18px !important',
    color: '#000000',
    '& a:hover': {
      color: 'rgba(128,128,128,0.7)',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px !important',
    },
  },

  iconMenu: {
    fill: '#ffffff',
    paddingRight: '24px'
  },

  iconMenuBlack: {
    fill: '#000000',
    paddingRight: '24px'
  },

  iconMenuMobile: {
    fill: '#ffffff',
    position: 'absolute',
    right: '10px',
    top: '24px',
    paddingRight: '24px'
  },

  menuMobilePaper: {
    top: '0px !important',
    right: '0px',
    left: 'unset !important',
    backgroundColor: '#000000',
    fontFamily: ['"Brown"'].join(','),
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#FFFFFF',
    width: '60%',
    fontSize: '24px',
  },

  menuMobileList:{
    padding: '80px 0 30px 40px',
  },

  menuMobileItem:{
    fontFamily: ['"Brown"'].join(','),
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#FFFFFF',
    fontSize: '18px',
  },

}));
export default NavBarStyle;
